<ng-template #propertyTemplate let-column="column" let-association="association">
	@for (property of column.properties; track property) {
		@if (hasDescriptionValue(association, property, true)) {
			<stages-description-view
				descriptionClass="{{ property.class }} shift-font-size"
				[html]="getValue(association, property, true)!"
			/>
		}
		@if (!hasDescriptionValue(association, property, true)) {
			<div class="{{ property.class }}">
				<ng-container>{{ getValue(association, property, true) }}</ng-container>
			</div>
		}
	}
</ng-template>

@if (associations$ | async; as associations) {
	<table class="process-table">
		<thead>
			<tr>
				@for (column of $any(columns); track column) {
					<th [class]="$any(column).class" scope="col">
						<span class="visually-hidden">{{ $any(column).nameKey | translate }}</span>
					</th>
				}
			</tr>
		</thead>
		<tbody>
			@for (association of associations; track association) {
				<tr>
					@for (column of $any(columns); track column) {
						<td class="{{ column.class }} process-table-cell">
							@if (column.isLinkable) {
								<a [routerLink]="getRoute(association)">
									<ng-container
										*ngTemplateOutlet="propertyTemplate; context: { column: column, association: association }"
									></ng-container>
								</a>
							}
							@if (!column.isLinkable) {
								<ng-container
									*ngTemplateOutlet="propertyTemplate; context: { column: column, association: association }"
								></ng-container>
							}
						</td>
					}
				</tr>
			}
		</tbody>
	</table>
}
